import React from 'react';
import '../../css/Skeleton.css';

/**
 * Skeleton — shimmering loading placeholder.
 *
 * Props:
 *   width / height — CSS sizes (number → px)
 *   circle         — render a circular avatar placeholder
 *   text           — text-line proportions
 *   radius         — override border-radius
 */
const Skeleton = ({ width, height, circle = false, text = false, radius, className = '', style }) => {
    const cls = [
        'qd-skeleton',
        circle ? 'qd-skeleton--circle' : '',
        text ? 'qd-skeleton--text' : '',
        className,
    ].filter(Boolean).join(' ');

    return (
        <span
            className={cls}
            aria-hidden="true"
            style={{ width, height, borderRadius: radius, ...style }}
        />
    );
};

export default Skeleton;
